import { mdiPlus } from '@mdi/js';
import AmountPicker from 'components/AmountPicker/AmountPicker';
import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import { MATERIAL_DECIMAL_PLACES } from 'helpers/materialHelpers';

interface MaterialAmountPickerProps {
  value?: number;
  maxAmount?: number | null;
  minAmount?: number;
  onChange: (value: number) => void;
}

const MaterialAmountPicker = ({
  onChange,
  maxAmount,
  minAmount,
  value
}: MaterialAmountPickerProps) => {
  return (
    <div className="MaterialAmountPicker">
      {!value || value === 0 ? (
        <Button
          icon={<Icon path={mdiPlus} />}
          onClick={() => onChange(maxAmount && maxAmount < 1 ? maxAmount : 1)}
        />
      ) : (
        <AmountPicker
          onChange={onChange}
          value={value}
          decimalPlaces={MATERIAL_DECIMAL_PLACES}
          maxAmount={maxAmount}
          minAmount={minAmount}
        />
      )}
    </div>
  );
};

export default MaterialAmountPicker;
